import * as React from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
const StyledButton = styled(Button)`
  max-width: 100%;
  height: auto;
  text-align: left;

  .mantine-Button-inner {
    justify-content: flex-start;
    display: inline-flex;
  }

  .mantine-Button-inner,
  .mantine-Button-label {
    max-width: 100%;
    white-space: normal;
  }
`;
const RowTitleButton = ({ children, onClick }) => /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "link", onClick }, children);
export default RowTitleButton;
